export const NONE = '@application/none';
export const UI_ACTION = '@application/drawer/ui_action';
export const RESIZE_ACTION = '@application/drawer/resize_action';
